import classNames from 'classnames';
import { curry } from 'lodash';
import { createElement } from 'react';

export type ComponentWithClassNameProps = {
    children?: React.ReactNode[] | React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    id?: string;
};

export const componentWithClassName = curry(
    (
        componentOrTag: string | React.ComponentType<any>,
        otherClassName: string,
        { children = undefined, className = undefined, style = undefined, id = undefined }: ComponentWithClassNameProps
    ): React.ReactElement => {
        const props = {
            style,
            id,
            className: classNames(otherClassName, className),
        };
        return createElement(componentOrTag, props, children);
    }
);

export const divWithClassName = componentWithClassName('div');
